import * as ScoreType from 'constants/ScoreType';
import * as GroupType from 'constants/GroupType';
import * as Period from 'constants/Period';

import * as MatchInfo from 'constants/MatchInfo';

const ICE_HOCKEY_SCORE_MAP = {};
ICE_HOCKEY_SCORE_MAP[Period.NOT_STARTED] = {
    [GroupType.DEFAULT_GROUP]: {
        info: MatchInfo.MATCH_NOT_STARTED,
        main: ScoreType.Match
    },
    [GroupType.FIRST_PERIOD_GROUP]: {
        main: ScoreType.FirstPeriod
    },
    [GroupType.SECOND_PERIOD_GROUP]: {
        main: ScoreType.SecondPeriod
    },
    [GroupType.THIRD_PERIOD_GROUP]: {
        main: ScoreType.ThirdPeriod
    }
};

ICE_HOCKEY_SCORE_MAP[Period.FIRST] = {
    [GroupType.DEFAULT_GROUP]: {
        main: ScoreType.Match,
        powerplay: ScoreType.PowerPlay
    },
    [GroupType.FIRST_PERIOD_GROUP]: {
        main: ScoreType.FirstPeriod
    },
    [GroupType.SECOND_PERIOD_GROUP]: {
        main: ScoreType.SecondPeriod
    },
    [GroupType.THIRD_PERIOD_GROUP]: {
        main: ScoreType.ThirdPeriod
    }
};

ICE_HOCKEY_SCORE_MAP[Period.FIRST_BREAK] = {
    [GroupType.DEFAULT_GROUP]: {
        info: MatchInfo.INTERMISSION,
        main: ScoreType.Match,
        additional: [ScoreType.FirstPeriod]
    },
    [GroupType.FIRST_PERIOD_GROUP]: {
        main: ScoreType.FirstPeriod
    },
    [GroupType.SECOND_PERIOD_GROUP]: {
        main: ScoreType.SecondPeriod
    },
    [GroupType.THIRD_PERIOD_GROUP]: {
        main: ScoreType.ThirdPeriod
    }
};

ICE_HOCKEY_SCORE_MAP[Period.SECOND] = {
    [GroupType.DEFAULT_GROUP]: {
        main: ScoreType.Match,
        powerplay: ScoreType.PowerPlay,
        additional: [ScoreType.FirstPeriod]
    },
    [GroupType.FIRST_PERIOD_GROUP]: {
        main: ScoreType.FirstPeriod
    },
    [GroupType.SECOND_PERIOD_GROUP]: {
        main: ScoreType.SecondPeriod
    },
    [GroupType.THIRD_PERIOD_GROUP]: {
        main: ScoreType.ThirdPeriod
    }
};

ICE_HOCKEY_SCORE_MAP[Period.SECOND_BREAK] = {
    [GroupType.DEFAULT_GROUP]: {
        info: MatchInfo.INTERMISSION,
        main: ScoreType.Match,
        additional: [ScoreType.FirstPeriod, ScoreType.SecondPeriod]
    },
    [GroupType.FIRST_PERIOD_GROUP]: {
        main: ScoreType.FirstPeriod
    },
    [GroupType.SECOND_PERIOD_GROUP]: {
        main: ScoreType.SecondPeriod
    },
    [GroupType.THIRD_PERIOD_GROUP]: {
        main: ScoreType.ThirdPeriod
    }
};

ICE_HOCKEY_SCORE_MAP[Period.THIRD] = {
    [GroupType.DEFAULT_GROUP]: {
        main: ScoreType.Match,
        powerplay: ScoreType.PowerPlay,
        additional: [ScoreType.FirstPeriod, ScoreType.SecondPeriod]
    },
    [GroupType.FIRST_PERIOD_GROUP]: {
        main: ScoreType.FirstPeriod
    },
    [GroupType.SECOND_PERIOD_GROUP]: {
        main: ScoreType.SecondPeriod
    },
    [GroupType.THIRD_PERIOD_GROUP]: {
        main: ScoreType.ThirdPeriod
    }
};

ICE_HOCKEY_SCORE_MAP[Period.THIRD_BREAK] = {
    [GroupType.DEFAULT_GROUP]: {
        info: MatchInfo.INTERMISSION,
        main: ScoreType.Match,
        additional: [ScoreType.FirstPeriod, ScoreType.SecondPeriod, ScoreType.ThirdPeriod]
    },
    [GroupType.FIRST_PERIOD_GROUP]: {
        main: ScoreType.FirstPeriod
    },
    [GroupType.SECOND_PERIOD_GROUP]: {
        main: ScoreType.SecondPeriod
    },
    [GroupType.THIRD_PERIOD_GROUP]: {
        main: ScoreType.ThirdPeriod
    }
};

ICE_HOCKEY_SCORE_MAP[Period.OVERTIME] = {
    [GroupType.DEFAULT_GROUP]: {
        main: ScoreType.Match,
        additional: [ScoreType.FirstPeriod, ScoreType.SecondPeriod, ScoreType.ThirdPeriod],
        overtime: ScoreType.Overtime
    }
};

ICE_HOCKEY_SCORE_MAP[Period.PENALTIES] = {
    [GroupType.DEFAULT_GROUP]: {
        main: ScoreType.Match,
        additional: [ScoreType.FirstPeriod, ScoreType.SecondPeriod, ScoreType.ThirdPeriod]
    }
};
ICE_HOCKEY_SCORE_MAP[Period.FINISHED] = {
    [GroupType.DEFAULT_GROUP]: {
        info: MatchInfo.MATCH_FINISHED,
        main: ScoreType.Match,
        additional: [ScoreType.FirstPeriod, ScoreType.SecondPeriod, ScoreType.ThirdPeriod],
        overtime: ScoreType.Overtime
    }
};

export default ICE_HOCKEY_SCORE_MAP;


// WEBPACK FOOTER //
// ./js/sport-betting/components/grid-control/sportGlossary/IceHockey/ScoreMap.js